import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomerPackageOfferLog, getCustomerPackageOfferSubscriptionLog, paginationCustomerPackageOfferSubscriptionLog, postCustomerPackageOfferLog, postCustomerPackageOfferLogSubscriberLedger } from "../../../services/CustomerPackageOffer/CustomerPackageOffer";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ButtonLink from "../../../ButtonLink";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";

const { innerWidth: width, innerHeight: height } = window;

const CustomerPackageOfferSubscriptionLog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { brandId, storeId, storeCustomerId, item, customerData } = location.state || {};


  const { userProfileRole } = getUserData();

  const { storeLocalData } = getStoreLocalData();
  const userRole = userProfileRole;

  const [loading, setLoading] = useState(false);
  const [useEffectCall, setUseEffectCall] = useState(false);
  const [sortingData, setSortingData] = useState(true);

  const formatDateLedger = (dateString) => {
    const parsedDate = new Date(dateString.replace("", ""));

    return parsedDate.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour12: true,
      hour: 'numeric',
      minute: '2-digit',
    });
  };

  const [page, setPage] = useState(0);

  const [isEndReached, setIsEndReached] = useState(false);
    const ds = useRef(null);
  const [customerPackageOfferSubscriptionLogData, setCustomerPackageOfferSubscriptionLogData] =
    useState([]);

  const fetchCustomerPackageOfferSubscriptionLogList = (data, page = 0) => {
    paginationCustomerPackageOfferSubscriptionLog(brandId, storeId, item.id, {
      ...data,
      limit: 10,
      offset: page * 10, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (page === 0) {
            setCustomerPackageOfferSubscriptionLogData(Res);
          } else {
            setCustomerPackageOfferSubscriptionLogData((prevData) => {
              const existingIds = new Set(
                prevData.map((item) => item.createdDate)
              );
              const newUniqueData = Res.filter(
                (item) => !existingIds.has(item.createdDate)
              );
              const updatedData = [...prevData, ...newUniqueData];

              return updatedData;
            });
          }

          setLoading(false);
          // setSearchTermClean(false);
          setIsEndReached(Res.length < 10);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      // subscriberId: item.id,
      sortOrder: sortingData ? "asc" : "desc",
    }
    fetchCustomerPackageOfferSubscriptionLogList(data, 0);
  }, []);

  const handleSortData = () => {
    setSortingData(!sortingData);
    const data = {
      // subscriberId: item.id,
      sortOrder: !sortingData ? "asc" : "desc",
    }
    fetchCustomerPackageOfferSubscriptionLogList(data, 0);
  };

    useEffect(() => {
      const data = {
        // subscriberId: item.id,
        sortOrder: sortingData ? "asc" : "desc",
      }
      if (page > 0) fetchCustomerPackageOfferSubscriptionLogList(data, page);
      }, [page]);

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };

  const ledgerModeData = {
    DEFAULT: "#a5faf0",
  };

  const renderCardItem2 = (data) => {
      return (
        <div
          className="flex-1 flex flex-row mx-2 justify-content-between"
          style={{ backgroundColor: `${ledgerModeData.DEFAULT}` }}
        >
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {formatDateLedger(data.createdDate)}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {storeLocalData?.currencySymbol} {data.paymentInfo.amount}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {data.paymentInfo.paymentMode}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {!data.paymentInfo.processed ? (
              <img
                src={
                  "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                }
                style={{
                  width: 20,
                }}
              />
            ) : (
              <img
                src={
                  "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                }
                style={{
                  alignSelf: "center",

                  width: 20,
                }}
              />
            )}
          </p>
        </div>
      );
  };

  let rows = "";
  
    customerPackageOfferSubscriptionLogData.forEach((entry) => {
      rows += `
      <div class="table-head">
        <div class="table-cell-head">${formatDateLedger(entry.createdDate)}</div>
        <div class="table-cell-head2">{storeLocalData?.currencySymbol} ${entry.paymentInfo.amount}</div>
        <div class="table-cell-head">{storeLocalData?.currencySymbol} ${entry.paymentInfo.paymentMode}</div>
        <div class="table-cell-head2">${entry.paymentInfo.processed ? "YES" : "NO"}</div>
      </div>`;
    });
  
    const offerName = item.brandPackageOffer?.name?.replace(/_/g, " ");
  
    const customerName =
      customerData?.brandCustomer?.firstName +
      " " +
      customerData?.brandCustomer?.lastName;
  
    const downloadPDF = (type) => {
      const doc = new jsPDF("landscape");
      const logoImg = new Image();
  
      // Set title of the document
      doc.setFontSize(20);
      doc.text(`Subscription - ${offerName} - Ledger`, 20, 20);
      doc.text(`Customer Name - ${customerName}`, 20, 35);
  
      // Format the table data from customerLedger
      const tableData = customerPackageOfferSubscriptionLogData.map((item) => {
        const ledgerModeColor = ledgerModeData.DEFAULT;
        // Format the particulars based on ledgerMode
        return [
          formatDateLedger(item.createdDate), // Date
          item.paymentInfo.amount,
          item.paymentInfo.paymentMode,
          item.paymentInfo.processed ? "Yes" : "No",
        ];
      });
  
      // Define table headers
      const tableHeaders = ["Subscribe On", "Amount", "Payment Mode", "Status"];
  
      // Generate the table using autoTable
      doc.autoTable({
        head: [tableHeaders],
        body: tableData,
        startY: 45, // Start position for the table
        theme: "grid",
        styles: {
          fontSize: 10,
        },
      });
  
      // Handle either print or download based on the `type` argument
      if (type === "print") {
        // Create blob URL and open it in a new window for printing
        const blob = doc.output("blob");
        const blobURL = URL.createObjectURL(blob);
        const printWindow = window.open(blobURL);
        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print();
          };
        }
      } else {
        let date = new Date();
        // Save as PDF file
        doc.save(
          `Subscription-${offerName}-Ledger-${Math.floor(
            date.getTime() + date.getSeconds() / 2
          )}`
        );
      }
    };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/CustomerPackageOffer", {
                    state: {
                      brandId: brandId,
                      storeIdValue: storeId,
                      storeCustomerId: storeCustomerId,
                      item: item,
                      customerData: customerData
                    }
                  })}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Consumer Discount
              </p>
            </div>
          </div>
          <div
            onClick={() => handleSortData()}
            className="cursor-pointer flex align-items-center"
          >
            {!sortingData ? (
              <i
                className="pi  pi-sort-amount-up-alt"
                style={{ fontSize: "25px", marginRight: 20, color: "#fff" }}
              ></i>
            ) : (
              <i
                className="pi  pi-sort-amount-down"
                style={{ fontSize: "25px", marginRight: 20, color: "#fff" }}
              ></i>
            )}
          </div>

          <div className="flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center cursor-pointer mr-2">
              <img
                onClick={() => downloadPDF("download")}
                src={"images/file.png"}
                style={{
                  width: height < 600 ? 25 : 30,
                }}
              />
            </div>
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={() => downloadPDF("print")}
                src={"Icons/printer.png"}
                style={{
                  width: height < 600 ? 25 : 30,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row py-1 mx-2 justify-content-between">
        <p className="flex-1 text-lg font-medium text-center">Subscribe On</p>
        <p className="flex-1 text-lg font-medium text-center">Amount</p>
        <p className="flex-1 text-lg font-medium text-center">Payment Mode</p>
        <p className="flex-1 text-lg font-medium text-center">Status</p>

      </div>
        <DataScroller
        value={customerPackageOfferSubscriptionLogData}
        itemTemplate={renderCardItem2}
        rows={customerPackageOfferSubscriptionLogData?.length + 10}
                    inline
                    ref={ds}
                    scrollHeight={height -150}
                    loader
                    // footer={footer}
                  />
                  <div
                          className="flex justify-content-center fixed "
                          style={{ bottom: 10, left: 20 }}
                        >
                          <Button
                            type="text"
                            icon="pi pi-plus"
                            // label="More"
                            onClick={getData} // Update this to trigger `getData`
                          />
                        </div>
      <ButtonLink />
    </div>
  );
};

export default CustomerPackageOfferSubscriptionLog;
